module.exports = require('./src')



//////////////////
// WEBPACK FOOTER
// ./node_modules/min-util/index.js
// module id = 19
// module chunks = 0